import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from "date-fns";

interface IsDateBetweenDaysArgs {
  date: Date;
  startDate: Date;
  endDate: Date;
}
export const isDateBetweenDays = ({ date, startDate, endDate }: IsDateBetweenDaysArgs) => {
  const start = startOfDay(startDate);
  const end = endOfDay(endDate);

  return isSameDay(date, start) || isSameDay(date, end) || (isAfter(date, start) && isBefore(date, end));
};
